import Routine, { RUN } from "+/Engine/Routine";
import DataTypes from "+/Engine/Helpers/DataTypes";

export default class CreateEntity extends Routine {
  assertValidParams(params) {
    DataTypes.assertObjectKeyExistsOfType("entityType", params, DataTypes.assertString);
    DataTypes.assertObjectKeyExistsOfType("fields", params, DataTypes.assertObject);
  }

  [RUN](params, contexts) {
    const entity = this.app.createTempEntity(params.entityType, params.fields, contexts);
    const entityFields = entity.getBasicFieldData();
    this.app.upsertEntity(entity.getType(), entity.getPk(), entityFields, true, "create entity routine");

    return entityFields;
  }
}
Routine.register("CreateEntity", CreateEntity);
